export default "__VITE_ASSET__CmX1IytN__"